import {
  FeatureTemplate,
  FeatureTemplateWithDetails,
} from "@/types/featureTemplate";
import { supabase } from "../supabase/supabase";

export const featureTemplateService = {
  async getFeatureTemplates(
    organizationId: string
  ): Promise<FeatureTemplateWithDetails[]> {
    const { data, error } = await supabase
      .from("feature_templates")
      .select(
        `
        *,
        assistant:assistants(id, name),
        schema_template:schema_templates(id, name)
      `
      )
      .order("created_at", { ascending: false });

    if (error) throw error;
    return data || [];
  },

  async getFeatureTemplate(id: string): Promise<FeatureTemplateWithDetails> {
    const { data, error } = await supabase
      .from("feature_templates")
      .select(
        `
        *,
        assistant:assistants(id, name),
        schema_template:schema_templates(id, name)
      `
      )
      .eq("id", id)
      .single();

    if (error) throw error;
    return data;
  },

  async createFeatureTemplate(
    data: Omit<FeatureTemplate, "id" | "created_at" | "updated_at">
  ): Promise<FeatureTemplate> {
    const { data: newTemplate, error } = await supabase
      .from("feature_templates")
      .insert({
        name: data.name,
        agent_id: data.agent_id,
        schema_template_id: data.schema_template_id,
        organization_id: data.organization_id,
        created_by: data.created_by,
        max_instances: data.max_instances,
        max_leads_per_instance: data.max_leads_per_instance,
        max_call_minutes_per_instance: data.max_call_minutes_per_instance,
        max_reports_per_instance: data.max_reports_per_instance,
      })
      .select()
      .single();

    if (error) throw error;
    return newTemplate;
  },

  async updateFeatureTemplate(
    id: string,
    data: Partial<FeatureTemplate>
  ): Promise<FeatureTemplate> {
    const updateData: any = {};

    // Only include fields that are defined
    if (data.name !== undefined) updateData.name = data.name;
    if (data.agent_id !== undefined) updateData.agent_id = data.agent_id;
    if (data.schema_template_id !== undefined)
      updateData.schema_template_id = data.schema_template_id;
    if (data.organization_id !== undefined)
      updateData.organization_id = data.organization_id;
    if (data.max_instances !== undefined)
      updateData.max_instances = data.max_instances;
    if (data.max_leads_per_instance !== undefined)
      updateData.max_leads_per_instance = data.max_leads_per_instance;
    if (data.max_call_minutes_per_instance !== undefined)
      updateData.max_call_minutes_per_instance =
        data.max_call_minutes_per_instance;
    if (data.max_reports_per_instance !== undefined)
      updateData.max_reports_per_instance = data.max_reports_per_instance;

    const { data: updatedTemplate, error } = await supabase
      .from("feature_templates")
      .update(updateData)
      .eq("id", id)
      .select()
      .single();

    if (error) throw error;
    return updatedTemplate;
  },

  async deleteFeatureTemplate(id: string): Promise<void> {
    const { error } = await supabase
      .from("feature_templates")
      .delete()
      .eq("id", id);

    if (error) throw error;
  },
};
